import { TextInput } from '@ksyos/design-system';
import { useId } from 'react';
import { getValidationErrorTranslation } from '@frontend/utils';
import type { FormContextProps } from '../elements/formContext';
import type { IFormGroupFieldExtraProps, IFormGroupFieldProps } from './FormGroupField';
import { FormContextConsumer } from '../elements/formContext';
import { FormGroupField } from './FormGroupField';

interface IInputTextProps {
    disabled?: boolean;
    dontValidateOnBlur?: boolean;
    error?: string;
    id?: string;
    maxLength?: number;
    nullable?: boolean;
    onBlur?: (value: string | null) => void;
    onChange: (value: string | null) => void;
    onDoValidate?: () => void;
    placeholder?: string;
    tabIndex?: number;
    value: string | null;
}

export function InputText(props: FormContextProps<IInputTextProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => (
                <TextInput
                    disabled={props.disabled}
                    error={getValidationErrorTranslation(properties.error)}
                    id={props.id}
                    maxLength={props.maxLength}
                    name={(props as any).fieldKey}
                    onBlur={(e) => {
                        if (properties.onDoValidate && !properties.dontValidateOnBlur) {
                            properties.onDoValidate();
                        }
                        if (properties.onBlur) {
                            properties.onBlur(props.nullable && e.target.value === '' ? null : e.target.value);
                        }
                    }}
                    onChange={(e) =>
                        properties.onChange(props.nullable && e.target.value === '' ? null : e.target.value)
                    }
                    placeholder={props.placeholder}
                    tabIndex={props.tabIndex}
                    value={properties.value ? properties.value : ''}
                />
            )}
        </FormContextConsumer>
    );
}

export function InputTextField(
    props: FormContextProps<IInputTextProps & IFormGroupFieldProps & IFormGroupFieldExtraProps>
) {
    const id = useId();

    return (
        <FormGroupField
            htmlFor={id}
            {...props}
        >
            <InputText
                id={id}
                {...props}
            />
        </FormGroupField>
    );
}
